import { OptimizelyProduct } from '../types/DataSyncItem';
import { INCOMPLETE } from '../types/FieldMapping';
import {
  FIELD_PATH_SEPARATOR,
  FieldDefinition,
} from '../types/FieldDefinition';
import { FieldMappingEntry } from '../types/DataSyncViewModel';

const hasArrayFields = (
  field: FieldDefinition
): field is FieldDefinition & { array: { fields: FieldDefinition[] } } => {
  return (
    field.array !== undefined &&
    typeof field.array === 'object' &&
    'fields' in field.array
  );
};

export const findFieldByPath = (
  fields: FieldDefinition[],
  path: string
): FieldDefinition | undefined => {
  const pathParts = path.split('/');

  if (pathParts.length === 1) {
    return fields.find((field) => field.name === path);
  }

  const [firstPart, ...remainingParts] = pathParts;
  const parentField = fields.find((field) => field.name === firstPart);

  if (!parentField) {
    return undefined;
  }

  // Handle nested object fields
  if (parentField.object_schema?.fields) {
    return findFieldByPath(
      parentField.object_schema.fields,
      remainingParts.join(FIELD_PATH_SEPARATOR)
    );
  }

  // Handle arrays with object schemas
  if (hasArrayFields(parentField)) {
    return findFieldByPath(
      parentField.array.fields,
      remainingParts.join(FIELD_PATH_SEPARATOR)
    );
  }

  return undefined;
};

export function resetSourceFieldMappings(
  field_mappings: FieldMappingEntry[]
): FieldMappingEntry[] {
  return field_mappings.map(({ destinationField, disabled }) => ({
    destinationField,
    sourceField: INCOMPLETE,
    disabled,
  }));
}

export function resetDestinationFieldMappings(
  field_mappings: FieldMappingEntry[]
): FieldMappingEntry[] {
  return field_mappings.map(({ sourceField, disabled }) => ({
    destinationField: INCOMPLETE,
    sourceField,
    disabled,
  }));
}

export function getObjectLabel(product: string): string {
  return product === OptimizelyProduct.CGR ? 'Content Type' : 'Object';
}

export function getNotificationLabelForObject(product: string): string {
  return product === OptimizelyProduct.CGR ? 'a content type' : 'an object';
}
